import { BaseEntity, InlineContainerService } from 'yt-ng-framework';
import { Component } from "@angular/core";
import { BaseInlineUpdateComponent } from 'yt-ng-framework';
import { DokumentStavka } from './dokument-stavka';

@Component({
    selector: 'yt-dokument-stavka-inline-update',
    templateUrl: './dokument-stavka-inline-update.component.html'
})
export class DokumentStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<DokumentStavka> {
    constructor(protected inlineContainerService: InlineContainerService<DokumentStavka>){
        super(inlineContainerService);
    }
}